import { AUTH_LOGIN } from "./firebase";

/** Firebase ID token for HTTP Cloud Functions gated by requireHttpAdmin. */
export async function adminAuthHeaders() {
  const user = AUTH_LOGIN.currentUser;
  if (!user) {
    throw new Error("Sign in as an admin to continue");
  }
  const token = await user.getIdToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}
